import { User } from "../../models/user";

export namespace Users 
{
    export class AppLoaded
    {
        static readonly type = "[App] App Loaded";
    }

    export class UserLoggedIn 
    {
      static readonly type = "[Login Action] User Logged In";
      constructor(public payload: { user: User }) {}
    }

    export class UserLoginFailed
    {
        static readonly type = "[Login Action] Login Failed";
        constructor(public payload:{error: string}) {} 
    }

    export class UserLoggedOut
    {

    }

    export class UserUpdated
    {
        static readonly type = "[User Action] User Updated";
        constructor(public payload:{user: User}) {}
    }

    export class UserInserted
    {
        static readonly type = "[User action] User Inserted";
        constructor(public payload:{user: User}) {}    
    }
    
    export class UserDeleted
    {
        static readonly type = "[User action] User Deleted";
        constructor(public payload:{user: User}) {}
    }

    export class UserAssignedEncounter
    {
        static readonly type = "[User action] User Assigned Encounter";
        constructor(public payload:{user: User}) {}
    }

    export class UserUnassignedEncounter
    {
        static readonly type = "[User action] User Unassigned Encounter";
        constructor(public payload:{user: User}) {}
    }

}